import { render, staticRenderFns } from "./scoreDetails.vue?vue&type=template&id=44ba9721&"
import script from "./scoreDetails.vue?vue&type=script&lang=js&"
export * from "./scoreDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports